module.exports = __webpack_public_path__ + "img/mypic1.8e7d05f5.png";